import FormInputTypes from '../components/atoms/formEnums/formInputTypes';


export default {
  title: 'Legacy values',
  attributeName: 'legacy',
  fields: [
    {
      attributeName: 'isLive',
      helpText: 'LEGACY-this value continues to be used, but always overriden in the code. This must be 1 for live streaming and 0 for on demand content',
      type: FormInputTypes.CHECKBOX,
      label: 'Is Live',
      default: false,
    },
    {
      attributeName: 'manifestFile',
      helpText: 'LEGACY-this value continues to be in the codebase, but is always overridden. Consider deprecating.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Manifest file URL',
      placeholder: 'Input the Manifest file URL...',
    }
  ],
};
